export const locationPreferencesKeys = {
  withRemote: 'cv.detail.available.remote2',
  onCompanyPremises: 'cv.detail.available.company.office',
  travel: 'cv.detail.available.field.trips',
  relocation: 'cv.detail.available.relocation',
} as { [key: string]: string };
